import { render, staticRenderFns } from "./marketplace-card.component.vue?vue&type=template&id=05a52efa&scoped=true"
import script from "./marketplace-card.component.vue?vue&type=script&lang=js"
export * from "./marketplace-card.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-card.component.vue?vue&type=style&index=0&id=05a52efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a52efa",
  null
  
)

export default component.exports